import "./listSelect.css"

const ListSelect =(props) => {
    return (
        <div className="listSelect">

            <label htmlFor="select">{props.label}</label>
            <select defaultValue="" onChange={props.handleSelectValue}>
            <option value="" disabled>------------------</option>
            {props.selectList.map((option) => (
            <option key={option.id} value={option.id}>{option.name}</option>
          ))}
        </select>


        </div>
    )
}
export default ListSelect